// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogContent__dialogContent___3ohn0","inset":"DialogContent__inset___3WhYB","mobile":"DialogContent__mobile___1hoKx"};